(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["class-calendar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
    var PAL = ['#1C1B1B', '#A66F00', '#2F6F5E', '#9A4A2A', '#41557F', '#7A3E62', '#5E6B2A', '#6B5646'];

    function pad(n) { return String(n).padStart(2, '0'); }
    function key(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
    function parseKey(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }

    function readDate(label) {
      var t = label || '';
      var date = null, m;
      if ((m = t.match(/(\d{4})-(\d{1,2})-(\d{1,2})/))) date = m[1] + '-' + pad(m[2]) + '-' + pad(m[3]);
      else if ((m = t.match(/(\d{1,2})(?:st|nd|rd|th)?\s+(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*\.?,?\s+(\d{4})/i))) date = m[3] + '-' + pad(MONTHS[m[2].toLowerCase()] + 1) + '-' + pad(m[1]);
      else if ((m = t.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/))) date = m[3] + '-' + pad(m[2]) + '-' + pad(m[1]);
      if (!date) return null;
      var rest = t.replace(m[0], ' ');
      var T = '(\\d{1,2})(?:[:.](\\d{2}))?\\s*(am|pm)?';
      var times = rest.match(new RegExp('(?:^|[^\\d/])' + T + '(?:\\s*[-–]\\s*' + T + ')?', 'i'));
      if (times && !times[2] && !times[3] && !times[6]) times = null;
      if (times) times = [times[0], times[1], times[2] || '00', times[3], times[4], times[5] || '00', times[6]];
      function hhmm(h, mi, ap) {
        h = +h;
        if (ap) { ap = ap.toLowerCase(); if (ap === 'pm' && h < 12) h += 12; if (ap === 'am' && h === 12) h = 0; }
        return pad(h) + ':' + mi;
      }
      return {
        date: date,
        start: times ? hhmm(times[1], times[2], times[3] || times[6]) : '',
        end: times && times[4] ? hhmm(times[4], times[5], times[6]) : ''
      };
    }

    function init(root) {
      if (root.dataset.ccReady) return;
      root.dataset.ccReady = '1';
      var data;
      try { data = JSON.parse(root.querySelector('[data-cc-data]').textContent); } catch (e) { return; }
      var locale = document.documentElement.lang || undefined;
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var todayKey = key(today);

      var colours = {}, ci = 0;
      var sessions = [];
      function addSession(s, d) {
        s.date = d.date; s.past = d.date < todayKey; s.start = d.start; s.end = d.end;
        s.ckey = String(s.title || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (s.color) colours[s.ckey] = colours[s.ckey] || s.color;
        sessions.push(s);
      }
      data.sessions.forEach(function (s) {
        var lines = String(s.course || '').split(/\n+/).map(function (l) { return l.trim(); }).filter(Boolean);
        if (lines.length) {
          var ds = lines.map(readDate).filter(Boolean).sort(function (a, b) { return (a.date + a.start).localeCompare(b.date + b.start); });
          var f0 = ds[0], firstAt = f0 ? parseKey(f0.date) : null;
          if (firstAt && f0.start) { var hm = f0.start.split(':'); firstAt.setHours(+hm[0], +hm[1]); }
          var started = firstAt && new Date() >= firstAt;
          ds.forEach(function (d, i) {
            var c = {}; for (var k in s) c[k] = s[k];
            if (started) { c.available = false; c.closed = true; }
            c.courseIdx = i + 1; c.courseTotal = ds.length; c.courseDates = ds;
            addSession(c, d);
          });
          return;
        }
        var d = readDate(s.label);
        if (d) addSession(s, d);
      });
      sessions.sort(function (a, b) { return (a.date + a.start).localeCompare(b.date + b.start); });
      sessions.forEach(function (s) {
        if (!(s.ckey in colours)) colours[s.ckey] = PAL[ci++ % PAL.length];
        if (!s.color) s.color = colours[s.ckey];
      });

      var upCount = {}, seenV = {};
      sessions.forEach(function (s) { if (!s.past && !seenV[s.variantId]) { seenV[s.variantId] = 1; upCount[s.productId] = (upCount[s.productId] || 0) + 1; } });
      sessions.forEach(function (s) { s.oneDay = !s.past && !s.courseTotal && upCount[s.productId] === 1; });
      function courseTag(s) { return s.courseTotal ? '<span class="cc__one cc__course">' + s.courseTotal + '-WEEK COURSE · Week ' + s.courseIdx + ' of ' + s.courseTotal + '</span>' : ''; }
      var ONE = '<span class="cc__one">★ ONE DAY ONLY</span>';

      var byDay = {};
      sessions.forEach(function (s) { (byDay[s.date] = byDay[s.date] || []).push(s); });

      var grid = root.querySelector('[data-cc-grid]');
      var list = root.querySelector('[data-cc-list]');
      var hint = root.querySelector('[data-cc-hint]');
      var monthEl = root.querySelector('[data-cc-month]');
      var empty = root.querySelector('[data-cc-empty]');
      var prev = root.querySelector('[data-cc-prev]');
      var next = root.querySelector('[data-cc-next]');

      var upcoming = sessions.filter(function (s) { return !s.past; });
      var first = upcoming.length ? parseKey(upcoming[0].date) : today;
      var view = new Date(first.getFullYear(), first.getMonth(), 1);
      var minView = new Date(today.getFullYear(), today.getMonth(), 1);
      var selected = null;

      var fmtMonth = new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' });
      var fmtDow = new Intl.DateTimeFormat(locale, { weekday: 'short' });
      var fmtDay = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long' });

      function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
      function isLow(s) { return data.showSpaces && s.available && s.spaces !== null && s.spaces <= data.lowAt; }
      function timeRange(s) { return s.start ? s.start + (s.end ? '–' + s.end : '') : ''; }

      function spacesHtml(s) {
        if (!data.showSpaces || s.spaces === null || !s.available) return '';
        var n = s.spaces, low = n <= data.lowAt;
        var txt = (low ? data.labels.lowLeft : (n === 1 ? data.labels.spaceLeft : data.labels.spacesLeft)).replace('{count}', n);
        return '<div class="cc__spaces' + (low ? ' cc__spaces--low' : '') + '">' + esc(txt) + '</div>';
      }

      function initials(n) { return String(n || '?').split(/\s+/).map(function (w) { return w[0]; }).slice(0, 2).join('').toUpperCase(); }
      function avatar(t, cls) {
        return t.photo
          ? '<img class="' + cls + '" src="' + esc(t.photo) + '" alt="" loading="lazy">'
          : '<span class="' + cls + ' cc__ini">' + esc(initials(t.name)) + '</span>';
      }
      function tutorHtml(s) {
        if (!s.tutor || !s.tutor.name) return '';
        return '<button type="button" class="cc__tutor" data-tutor="' + sessions.indexOf(s) + '" aria-label="' + esc(data.labels['with'] + ': ' + s.tutor.name) + '" title="' + esc(s.tutor.name) + '">' + avatar(s.tutor, 'cc__av') + '</button>';
      }
      var dlg = root.querySelector('[data-cc-dialog]');
      function openTutor(t) {
        root.querySelector('[data-cc-dphoto]').innerHTML = avatar(t, 'cc__dlg-img');
        root.querySelector('[data-cc-dname]').textContent = t.name;
        var bio = root.querySelector('[data-cc-dbio]');
        bio.innerHTML = '';
        String(t.bio || '').split(/\n{2,}/).forEach(function (para) {
          if (!para.trim()) return;
          var pEl = document.createElement('p'); pEl.textContent = para.trim(); bio.appendChild(pEl);
        });
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      }
      root.querySelector('[data-cc-close]').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
      list.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tutor]');
        if (b) openTutor(sessions[+b.dataset.tutor].tutor);
      });

      var cdlg = root.querySelector('[data-cc-cdialog]');
      var products = data.products || {};
      function closeDlg(d) { if (d.close) d.close(); else d.removeAttribute('open'); }
      function openDlg(d) { if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', ''); }
      function openClass(s) {
        var info = products[String(s.productId)] || {};
        var imgs = (info.images && info.images.length) ? info.images : (s.image ? [s.image] : []);
        var main = root.querySelector('[data-cc-gmain]');
        var thumbs = root.querySelector('[data-cc-gthumbs]');
        function show(i) {
          main.innerHTML = imgs.length ? '<img src="' + esc(imgs[i]) + '" alt="' + esc(s.title) + '">' : '<div class="cc__gph" style="background:' + esc(s.color) + '"></div>';
          Array.prototype.forEach.call(thumbs.children, function (b, j) { b.classList.toggle('is-active', j === i); });
        }
        thumbs.innerHTML = imgs.length > 1 ? imgs.map(function (u, i) {
          return '<button type="button" data-gi="' + i + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(u) + '" alt="" loading="lazy"></button>';
        }).join('') : '';
        thumbs.onclick = function (e) { var b = e.target.closest('[data-gi]'); if (b) show(+b.dataset.gi); };
        show(0);
        var whenEl = root.querySelector('[data-cc-cwhen]');
        var whenTxt = fmtDay.format(parseKey(s.date)) + (timeRange(s) ? ' · ' + timeRange(s) : '');
        whenEl.hidden = !!s.oneDay;
        whenEl.textContent = whenTxt;
        root.querySelector('[data-cc-ctitle]').innerHTML = esc(s.title) + (s.oneDay ? '<br>' + ONE : '') + (s.courseTotal ? '<br><span class="cc__one cc__course">' + s.courseTotal + '-WEEK COURSE</span>' : '');
        whenEl.hidden = !!(s.oneDay || s.courseTotal);
        var oneBox = s.courseTotal ? '<div class="cc__onebox cc__coursebox"><small>One booking covers all ' + s.courseTotal + ' sessions</small><ol>' + s.courseDates.map(function (d) {
          return '<li' + (d.date < todayKey ? ' class="is-past"' : '') + '>' + esc(new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }).format(parseKey(d.date))) + (d.start ? ' · ' + esc(d.start + (d.end ? '–' + d.end : '')) : '') + '</li>';
        }).join('') + '</ol></div>' : s.oneDay ? '<div class="cc__onebox"><small>This class runs on one date only</small><b>📅 ' + esc(fmtDay.format(parseKey(s.date)) + ' ' + s.date.slice(0, 4)) + '</b>' + (timeRange(s) ? '<span>' + esc(timeRange(s)) + '</span>' : '') + '</div>' : '';
        root.querySelector('[data-cc-cmeta]').innerHTML = (s.level ? '<span class="cc__level">' + esc(s.level) + '</span>' : '') + esc(s.price);
        root.querySelector('[data-cc-cspaces]').innerHTML = s.past ? '' : spacesHtml(s);
        root.querySelector('[data-cc-ctutor]').innerHTML = s.tutor && s.tutor.name
          ? '<button type="button" class="cc__ctutor-btn" data-tutor="' + sessions.indexOf(s) + '">' + avatar(s.tutor, 'cc__av cc__av--sm') + '<span>' + esc(s.tutor.name) + '</span></button>'
          : '';
        root.querySelector('[data-cc-cdesc]').innerHTML = info.description || '';
        root.querySelector('[data-cc-ctabs]').innerHTML = (info.tabs || []).map(function (tab) {
          return '<details class="cc__tab"><summary>' + esc(tab.t) + '</summary><div class="cc__tab-body">' + tab.c + '</div></details>';
        }).join('');
        root.querySelector('[data-cc-cbook]').innerHTML = s.past
          ? '<span class="cc__btn cc__btn--off cc__btn--wide">' + esc(data.labels.finished) + '</span>'
          : s.available
            ? oneBox + qtyHtml(s) + '<button type="button" class="cc__btn cc__btn--wide" data-basket="' + sessions.indexOf(s) + '">' + esc(data.labels.basket) + '</button><p class="cc__ok" data-cc-ok hidden></p><p class="cc__err" data-cc-err hidden></p>'
            : '<span class="cc__btn cc__btn--off cc__btn--wide">' + esc(s.closed ? 'Course started' : data.labels.soldOut) + '</span>';
        openDlg(cdlg);
        cdlg.scrollTop = 0;
      }
      root.querySelector('[data-cc-cclose]').addEventListener('click', function () { closeDlg(cdlg); });
      cdlg.addEventListener('click', function (e) {
        if (e.target === cdlg) { closeDlg(cdlg); return; }
        var b = e.target.closest('[data-tutor]');
        if (b) openTutor(sessions[+b.dataset.tutor].tutor);
      });
      root.addEventListener('click', function (e) {
        var link = e.target.closest('[data-class]');
        if (!link) return;
        e.preventDefault();
        openClass(sessions[+link.dataset.class]);
      });

      function qtyHtml(s) {
        var max = s.spaces !== null ? Math.max(1, s.spaces) : 10;
        if (max < 2) return '';
        var opts = '';
        for (var q = 1; q <= Math.min(max, 10); q++) opts += '<option value="' + q + '">' + q + '</option>';
        return '<label class="cc__qty">' + esc(data.labels.seats) + ' <select data-cc-qty>' + opts + '</select></label>';
      }
      var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      function goCheckout(s, btn, toBasket) {
        if (btn.dataset.busy) return;
        btn.dataset.busy = '1';
        var label = btn.textContent;
        btn.textContent = toBasket ? data.labels.addingBasket : data.labels.adding;
        var box = btn.closest('[data-cc-cbook]');
        var sel = box ? box.querySelector('[data-cc-qty]') : null;
        var err = box ? box.querySelector('[data-cc-err]') : null;
        var ok = box ? box.querySelector('[data-cc-ok]') : null;
        if (err) err.hidden = true;
        if (ok) ok.hidden = true;
        var qty = sel ? parseInt(sel.value, 10) || 1 : 1;
        var bundled = [];
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: bundled } })); } catch (x) {}
        var payload = { items: [{ id: s.variantId, quantity: qty }] };
        if (bundled.length) { payload.sections = bundled.join(','); payload.sections_url = routesRoot + 'variants/' + s.variantId; }
        var added;
        fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw j; return j; });
        }).then(function (j) {
          added = j;
          if (!toBasket) { window.location.href = routesRoot + 'checkout'; return; }
          return fetch(routesRoot + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            delete btn.dataset.busy;
            btn.textContent = label;
            var drawerTheme = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'drawer' && document.querySelector('cart-drawer');
            if (!drawerTheme) { window.location.href = routesRoot + 'cart'; return; }
            cart.sections = added.sections;
            closeDlg(cdlg);
            var items = added.items || [added];
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            if (ok) { ok.innerHTML = esc(data.labels.added) + ' <a href="' + routesRoot + 'cart">' + esc(data.labels.viewBasket) + '</a>'; ok.hidden = false; }
          });
        }).catch(function (e) {
          delete btn.dataset.busy;
          btn.textContent = label;
          var msg = (e && (e.description || e.message)) || data.labels.error;
          if (err) { err.textContent = msg; err.hidden = false; }
          else window.location.href = s.url;
        });
      }
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-book]');
        if (!b) return;
        e.preventDefault();
        goCheckout(sessions[+b.dataset.book], b, false);
      });
      root.addEventListener('click', function (e) {
        var b = e.target.closest('[data-basket]');
        if (!b) return;
        e.preventDefault();
        goCheckout(sessions[+b.dataset.basket], b, true);
      });

      function renderList(items) {
        list.innerHTML = items.map(function (s) {
          var img = s.image
            ? '<img src="' + esc(s.image) + '" alt="" loading="lazy" width="80" height="80">'
            : '<div class="cc__ph" style="background:' + esc(s.color) + '"></div>';
          var btn = s.past
            ? '<span class="cc__btn cc__btn--off">' + esc(data.labels.finished) + '</span>'
            : s.available
              ? '<a class="cc__btn" data-class="' + sessions.indexOf(s) + '" href="' + esc(s.url) + '">' + esc(data.labels.book) + '</a>'
              : '<span class="cc__btn cc__btn--off">' + esc(s.closed ? 'Course started' : data.labels.soldOut) + '</span>';
          var state = s.past ? ' cc__item--past' : (!s.available ? ' cc__item--full' : '');
          var badge = s.past ? data.labels.finished : (!s.available ? (s.closed ? 'Course started' : data.labels.soldOut) : '');
          return '<article class="cc__item' + state + '">' + (badge ? '<span class="cc__badge">' + esc(badge) + '</span>' : '') +
            '<a class="cc__thumb" data-class="' + sessions.indexOf(s) + '" href="' + esc(s.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
            '<div style="min-width:0"><div class="cc__when">' + esc(fmtDay.format(parseKey(s.date))) + (timeRange(s) ? ' · ' + esc(timeRange(s)) : '') + '</div>' +
            '<a class="cc__title" data-class="' + sessions.indexOf(s) + '" href="' + esc(s.url) + '">' + esc(s.title) + '</a>' + (s.oneDay ? ONE : '') + courseTag(s) +
            '<div class="cc__meta">' + (s.level ? '<span class="cc__level">' + esc(s.level) + '</span>' : '') + esc(s.price) + '</div>' + spacesHtml(s) + '</div>' + tutorHtml(s) +
            btn + '</article>';
        }).join('');
        empty.hidden = items.length > 0;
      }

      function render() {
        monthEl.textContent = fmtMonth.format(view);
        prev.disabled = view <= minView;
        var html = '';
        for (var i = 0; i < 7; i++) html += '<div class="cc__dow" role="columnheader">' + esc(fmtDow.format(new Date(2024, 0, 1 + i))) + '</div>';
        var cursor = new Date(view); cursor.setDate(1 - ((view.getDay() + 6) % 7));
        var monthItems = [];
        for (var c = 0; c < 42; c++) {
          var k = key(cursor);
          var inMonth = cursor.getMonth() === view.getMonth();
          if (!inMonth && c >= 35 && cursor.getDay() === 1) break;
          var items = inMonth ? (byDay[k] || []) : [];
          monthItems = monthItems.concat(items);
          var allFull = items.length && items.every(function (s) { return !s.available; });
          var cls = 'cc__day';
          if (allFull && k >= todayKey) cls += ' cc__day--full';
          if (!inMonth) cls += ' cc__day--out';
          if (k < todayKey) cls += ' cc__day--past';
          if (k === todayKey) cls += ' cc__day--today';
          if (items.length) cls += ' cc__day--has';
          if (selected === k) cls += ' cc__day--sel';
          var chips = items.slice(0, 3).map(function (s) {
            var left = data.showSpaces && s.available && !s.past && s.spaces !== null ? ' (' + s.spaces + ')' : '';
            var st = s.past ? ' cc__chip--past' : (s.available ? (isLow(s) ? ' cc__chip--low' : '') : ' cc__chip--out');
            var tag = s.past ? '' : (!s.available ? '<span class="cc__chip-tag">' + esc(s.closed ? 'Started' : data.labels.full) + '</span>' : '');
            return '<a class="cc__chip' + st + '" data-class="' + sessions.indexOf(s) + '" style="--c:' + esc(s.color) + '" href="' + esc(s.url) + '" title="' + esc(s.title + left) + '">' +
              tag + (s.start ? '<span class="cc__chip-time">' + esc(s.start) + ' </span>' : '') + esc((s.courseTotal ? 'Wk ' + s.courseIdx + '/' + s.courseTotal + ' ' : '') + (s.level ? s.level + ' - ' : '') + (s.short || s.title)) +
              '<span class="cc__chip-count">' + esc(left) + '</span></a>';
          }).join('') + (items.length > 3 ? '<span class="cc__more">+' + (items.length - 3) + '</span>' : '');
          var attrs = items.length
            ? ' role="button" tabindex="0" data-day="' + k + '" aria-label="' + esc(fmtDay.format(cursor)) + ', ' + items.length + ' ' + esc(data.labels.classes) + '"'
            : '';
          html += '<div class="' + cls + '"' + attrs + '><span class="cc__num">' + cursor.getDate() + '</span>' + chips + '</div>';
          cursor.setDate(cursor.getDate() + 1);
        }
        grid.innerHTML = html;
        hint.textContent = selected ? data.labels.oneDay.replace('{date}', fmtDay.format(parseKey(selected))) : data.labels.allMonth;
        renderList(selected ? (byDay[selected] || []) : monthItems.filter(function (s) { return !s.past; }));
      }

      grid.addEventListener('click', function (e) {
        if (e.target.closest('.cc__chip')) return;
        var day = e.target.closest('[data-day]');
        if (!day) return;
        selected = selected === day.dataset.day ? null : day.dataset.day;
        render();
        if (selected) list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
      grid.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-day]')) { e.preventDefault(); e.target.click(); }
      });
      prev.addEventListener('click', function () { selected = null; view.setMonth(view.getMonth() - 1); render(); });
      next.addEventListener('click', function () { selected = null; view.setMonth(view.getMonth() + 1); render(); });

      render();
    }

    function boot() { document.querySelectorAll('.cc').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
